import { useTranslation } from "@/i18n/useTranslation";

export function Trust() {
  const { t } = useTranslation();
  const items = [
    { num: t("stats.features"), label: t("stats.featuresLabel") },
    { num: t("stats.languages"), label: t("stats.languagesLabel") },
    { num: t("stats.compliance"), label: t("stats.complianceLabel") },
  ];
  return (
    <section className="py-12 md:py-14 border-y border-border bg-white">
      <div className="container mx-auto max-w-[1440px] px-5 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {items.map((it, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-primary tracking-tight">
                {it.num}
              </div>
              <div className="mt-1.5 text-[11px] uppercase tracking-wider text-muted-foreground font-medium">
                {it.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
